// browse-1d — interaction primitive.
//
// 1-dimensional cycling through slot products via keyboard input
// (typically arrow keys). Used today by longbox + shortbox once the lid
// is open; future shelf-row + bin-vertical kinds can adopt the same
// primitive for ↔ cycling.
//
// MIGRATION WINDOW (Phases 2c–6): stage.js's existing key handlers
// already cycle through `boxEntries[activeBoxId].comicEntries` when
// `boxState === "open"`. This primitive's job is to declare that the
// fixture-kind supports browse-1d behavior + ensure the composedEntry
// shape stage.js reads from is fully populated. The actual key handler
// stays in stage.js (one global handler that checks active fixture).
//
// AAA TARGET (Phase 6+): when stage.js's box state machine refactors
// into a per-fixture state-machine model, this primitive can own its
// own key handler, browseIndex state, and dispose closure.
//
// Manifest contract (manifest.interactions[N] kind="browse-1d"):
//   - target          must be "slots"
//   - trigger         "arrows" today (could expand to "scroll" / "swipe" later)
//   - requiresState   gate — e.g., "open" means only fires when fixture is open

import { registerInteraction } from "./index.js";

function wireBrowse1d(ctx) {
	const { interactionDef, slotResult, composedEntry } = ctx;
	if (!composedEntry) return;

	// Declarative: mark the fixture as browse-1d capable. Stage.js's
	// existing arrow-key handler checks for this on the active box entry.
	composedEntry.browse1d = {
		enabled:       true,
		trigger:       interactionDef?.trigger || "arrows",
		requiresState: interactionDef?.requiresState || "open",
		slotCount:     slotResult?.extras?.slotCount ?? 0,
	};
	// browseIndex starts at 0 (first product shown). Stage.js updates
	// this on arrow-key as the user cycles; the primitive just seeds it.
	if (typeof composedEntry.browseIndex !== "number") {
		composedEntry.browseIndex = 0;
	}

	// No dispose work today — the global key handler routes by activeBoxId,
	// not by registered handler reference. Phase 6+ refactor will return
	// a real dispose closure.
}

registerInteraction("browse-1d", wireBrowse1d);

export { wireBrowse1d };
